import React from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import { getThemeColors } from '../utils/themeStyles';

// Loader RÉUTILISABLE : spinner + message de l'ACTION EN COURS (thème-aware).
// À utiliser partout à la place d'un ActivityIndicator nu, avec un `label` explicite
// (« Chargement des missions… », « Enregistrement… », « Connexion… », etc.).
//   variant="inline" : ligne compacte (dans une barre/carte).
//   variant="block"  : bloc centré (plein conteneur).
export default function ActionLoader({
  label,
  variant = 'inline',
  size = 'small',
}: {
  label: string;
  variant?: 'inline' | 'block';
  size?: 'small' | 'large';
}) {
  const { isDarkTheme } = useTheme();
  const colors = getThemeColors(isDarkTheme);
  const content = (
    <View style={styles.row}>
      <ActivityIndicator size={size} color={colors.primary} style={{ marginRight: 10 }} />
      <Text style={[styles.label, { color: colors.textSecondary }]} numberOfLines={2}>
        {label}
      </Text>
    </View>
  );
  if (variant === 'block') {
    return <View style={[styles.block, { backgroundColor: colors.background }]}>{content}</View>;
  }
  return content;
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' },
  block: { flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24 },
  label: { fontSize: 14, fontWeight: '500', flexShrink: 1 },
});
